export default __webpack_public_path__ + "static/media/ladiko-drone.1d4adcb3.jpg";